import { SignUp } from '@clerk/clerk-react'
import React from 'react'

const Signup = () => {
  return (
    <div className="flex w-full h-screen overflow-clip">
      <div className="flex h-full w-full md:w-fit justify-center items-center bg-[#19191a]">
        <SignUp
          signInUrl="/login"
          afterSignUpUrl={'/join-group'}
          appearance={{
            elements: {
              headerTitle: 'text-center text-3xl mb-3 font-bold',
              headerSubtitle: 'text-center ',
              footerAction__signUp: 'text-center mx-auto justify-center',
            },
          }}
        />
      </div>

      <img
        src="/images/login.jpg"
        className="md:block hidden  w-full h-screen  object-center"
      />
    </div>
  )
}

export default Signup
